import { render, staticRenderFns } from "./CorporationsFilter.vue?vue&type=template&id=3adb9c74"
import script from "./CorporationsFilter.vue?vue&type=script&lang=ts"
export * from "./CorporationsFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports